import {useQuery} from '@tanstack/react-query';
import {InstantAnswer, SearchService} from 'client';
import {useDebouncedValue} from 'hooks/useDebounce';
import {getService} from 'utilities';

// Each request embeds the query, so wait for a slightly longer pause than the
// 200ms result search does.
const INSTANT_ANSWER_DEBOUNCE_MS = 300;
const MIN_QUERY_LENGTH = 3;

export type InstantAnswerResult = {
  query: string;
  answer: InstantAnswer | null;
  latencyMs: number;
};

export const useInstantAnswer = (query: string) => {
  const debounced = useDebouncedValue(query.trim(), INSTANT_ANSWER_DEBOUNCE_MS);
  return useQuery({
    queryKey: ['search', 'instant-answer', debounced],
    queryFn: async (): Promise<InstantAnswerResult> => {
      const started = performance.now();
      const response =
        await getService(SearchService).searchInstantAnswerApiV1SearchInstantAnswerGet(debounced);
      return {
        query: debounced,
        answer: response.answer ?? null,
        latencyMs: performance.now() - started,
      };
    },
    enabled: debounced.length >= MIN_QUERY_LENGTH,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
